import { render, staticRenderFns } from "./TrangTaoCapDonVi.vue?vue&type=template&id=0ccc545c&"
import script from "./TrangTaoCapDonVi.vue?vue&type=script&lang=js&"
export * from "./TrangTaoCapDonVi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports